import axios from 'axios';
import { useUserStore } from '../stores/user';
import { useAlerts } from '../stores/alerts';
import i18n from '../I18n';

export function setupAxiosInterceptor() {
	axios.interceptors.response.use(
		(response) => response,
		(error) => {
			if (error.response?.status === 401) {
				const { userLogout } = useUserStore.getState();
				const { addAlert } = useAlerts.getState();

				userLogout();
				addAlert({
					message: i18n.t('Current session is expired', { ns: 'Common' }),
				});
			}

			return Promise.reject(error);
		}
	);
}
